var _circle, _path, _path2, _circle2, _path3, _path4, _circle3, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgControlsAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "controlsAltIconTitle"
  }, "Controls") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "controlsAltIconTitle"
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 6,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6H20"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 18,
    r: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18H20"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 12,
    r: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H13"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12L20 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlsAlt);
export default __webpack_public_path__ + "static/media/controls-alt.329672a785e4ef1d549f9c7c68e2e608.svg";
export { ForwardRef as ReactComponent };